import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor() { }

  // amíg nincs skote-os notification addig csak console-ra írunk
  // https://themesbrand.com/skote/layouts/ui-notifications.html

  showInfo(message: string) {
    console.info(message);
  }

  showError(message: string, buttonLabel: string, timeDelay: number) {
    console.error(message);
  }
}
